module.exports = __webpack_public_path__ + "static/media/ios-keypad.eca7d6a6.svg";